import { render, staticRenderFns } from "./RoomTranslation.vue?vue&type=template&id=4e7d913b&scoped=true&"
import script from "./RoomTranslation.vue?vue&type=script&lang=js&"
export * from "./RoomTranslation.vue?vue&type=script&lang=js&"
import style0 from "./RoomTranslation.vue?vue&type=style&index=0&id=4e7d913b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7d913b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e7d913b')) {
      api.createRecord('4e7d913b', component.options)
    } else {
      api.reload('4e7d913b', component.options)
    }
    module.hot.accept("./RoomTranslation.vue?vue&type=template&id=4e7d913b&scoped=true&", function () {
      api.rerender('4e7d913b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/ExtendMenu/RoomTranslation/RoomTranslation.vue"
export default component.exports